import { createFileRoute } from '@tanstack/react-router'
import WorkCostAndIncome from 'Work/components/Work/Sections/Costs/WorkCostAndIncome'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/work/$workId/costs')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <WorkCostAndIncome />
        </Guard>
    ),
})
